<template>
	<div v-if="items.length" class="c-global-basket__kit-products product__starter-kit">
		<DsButton href="#" @click.prevent="toggle" variant="link" size="md" data-testid="toggler">
			{{ expandCollapseLabel }}
			<DsIcon icon-name="chevron-up" :class="expanded ? 'open' : ''" />
		</DsButton>
		<div class="items-container" :class="{ '-expanded': expanded }" :style="style">
			<div class="item-container" v-for="item in items" :key="item.name">
				<figure>
					<img :src="item.imageUrl" :alt="item.name">
				</figure>
				<div>
					<span class="item-name">{{ item.name }}</span>
					<span class="item-quantity">{{ quantityLabel }}: {{ item.quantity }}</span>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import { DsButton, DsIcon } from '@coloplast/design-system';

export default {
	props: {
		readMore: {
			type: String,
			required: false,
			default: ''
		},
		readLess: {
			type: String,
			required: false,
			default: ''
		},
		items: {
			type: Array,
			required: false,
		},
		quantityLabel: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			expanded: false,
			contentHeight: null,
		}
	},
	components: {
		DsButton,
		DsIcon
	},
	computed: {
		style () {
			let styles = {};
			if (this.contentHeight) {
				styles['max-height'] = `${this.contentHeight}px`;
			}
			return styles;
		},
		expandCollapseLabel() {
			if (this.expanded) return this.readLess;

			return this.readMore;
		}
	},
	methods: {
		toggle () {
			this.expanded = !this.expanded;
		},
	}
}

</script>
